import React from 'react';
import { Link } from 'react-router-dom';

const DuplicateSessionDialog = ({ session, onDismiss }) => {
  if (!session?.id) return null;

  return (
    <div className="rounded-lg border border-orange-200 bg-orange-50 p-4 space-y-3">
      <p className="text-sm font-medium text-orange-900">Duplicate session detected</p>
      <p className="text-sm text-orange-800">
        A recording for this case may already exist:{' '}
        <span className="font-medium">{session.title}</span>
      </p>
      <div className="flex flex-wrap gap-2">
        <Link
          to={`/transcriptions/${session.id}`}
          className="px-3 py-1.5 bg-orange-600 text-white rounded-lg text-sm hover:bg-orange-700"
          onClick={onDismiss}
        >
          View existing session
        </Link>
        <button
          type="button"
          onClick={onDismiss}
          className="px-3 py-1.5 border border-orange-300 text-orange-800 rounded-lg text-sm hover:bg-orange-100"
        >
          Dismiss
        </button>
      </div>
    </div>
  );
};

export default DuplicateSessionDialog;
